<template>
<div>
    <div class="menu-vert-top">{{ $t("use-designbox") }}
        <br>
        <h2>{{ getCompanyName }}</h2>
    </div>
    <div class="menu-vert-menu">
        <div class="menu-vert-menu-item"
            v-if="hasRedirect"
            @click="shopDeliveryClicked ()">{{ $t("to-shop") }}
        </div>
        <div class="menu-vert-menu-item" v-if="hasAnyPermission('IS_DEALER_ADMIN')" :class="{ active: isActive('companies')}">
            <router-link :to="{ name : 'companies', params : { cid: getCompany}}"
            >{{ $t("sub-companies") }}
            </router-link>
        </div>

        <div class="menu-vert-menu-item" v-if="hasAnyPermission('CAN_APPROVE_ORDER')" :class="{ active: isActive('approve-order')}">
            <router-link :to="{ name : 'order-approve' }">{{ $t("order-approve") }}
            </router-link>
            <div class="menu-vert-menu-item-item" v-if="hasAnyPermission('CAN_APPROVE_ORDER')" :class="{ active: isActive('order-reset')}">
                <router-link :to="{ name : 'order-reset' }"> {{ $t("order-reset") }}</router-link>
            </div>
        </div>

        <div class="menu-vert-menu-item" :class="{ active: isActive('mycompany')}">
            <router-link :to="{name : 'my-company'}">{{ $t("my-company") }}</router-link>
            <div class="menu-vert-menu-item-item" v-if="hasAnyPermission('CAN_CREATE_COMPANIES')" :class="{ active: isActive('create-company')}">
                <router-link :to="{ name : 'company-create'}"> {{ $t("create-company") }}</router-link>
            </div>
            <div class="menu-vert-menu-item-item" :class="{ active: isActive('overview-delivery')}">
                <router-link :to="{ name : 'delivery-overview'}">&gt; {{ $t("overview-delivery") }}
                </router-link>
            </div>
            <div class="menu-vert-menu-item-item" :class="{ active: isActive('create-delivery')}">
                <router-link :to="{ name : 'delivery-create'}">&gt; {{ $t("create-delivery") }}</router-link>
            </div>
        </div>

        <div class="menu-vert-menu-item" v-if="hasAnyPermission('IS_DEALER_ADMIN')" :class="{ active: isActive('overview-contacts')}">
            <router-link :to="{ name : 'contacts-overview' }">{{ $t("overview-contacts") }}</router-link>
            <div class="menu-vert-menu-item-item" v-if="hasAnyPermission('CAN_CREATE_CONTACTS')" :class="{ active: isActive('create-contact')}">
                <router-link :to="{ name : 'contacts-create' }">&gt; {{ $t("create-contact") }}</router-link>
            </div>
        </div>

        <div class="menu-vert-menu-item" v-if="hasAnyPermission('CAN_TRANSLATE')" :class="{ active: isActive('translation')}">
            {{ $t("translation") }}
            <div class="menu-vert-menu-item-item" :class="{ active: isActive('catalog-i18n')}">
                <router-link :to="{ name : 'catalog-list' }">{{ $t("catalog") }}</router-link>
            </div>
            <div class="menu-vert-menu-item-item" :class="{ active: isActive('vartext-i18n')}">
                <router-link :to="{ name : 'vartext' }">{{ $t("vartext") }}</router-link>
            </div>
        </div>
        <div class="menu-vert-menu-item" v-if="hasAnyPermission('CAN_UPLOAD', 'SEE_PRICELOGS', 'MANAGE_USERS')" :class="{ active: isActive('admin')}">
            {{ $t("admin") }}
            <div class="menu-vert-menu-item-item" v-if="hasAnyPermission('SEE_PRICELOGS')" :class="{ active: isActive('price-logs')}">
                <router-link :to="{ name : 'price-overview' }">{{ $t("price-logs") }}</router-link>
            </div>
            <div class="menu-vert-menu-item-item" v-if="hasAnyPermission('CAN_UPLOAD')" :class="{ active: isActive('upload-price')}">
                <router-link :to="{ name : 'files-upload' }">{{ $t("file-uploads") }}</router-link>
            </div>
            <div class="menu-vert-menu-item-item" v-if="hasAnyPermission('MANAGE_USERS')" :class="{ active: isActive('manage-users')}">
                <router-link :to="{ name : 'manage-users' }">{{ $t("manage-users") }}</router-link>
            </div>
            <div class="menu-vert-menu-item-item" v-if="hasAnyPermission('MANAGE_USERS')" :class="{ active: isActive('switch-user')}">
                <router-link :to="{ name : 'switch-user' }">{{ $t("switch-user") }}</router-link>
            </div>
        </div>
        <router-link :to="{name: 'Logout'}"><div class="menu-vert-menu-item-logout">{{ $t("logout") }}</div></router-link>
    </div>
 </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name:"MenuVert",
    props:["currentactive"],
    computed: {
        ...mapGetters([
            "getDeliveryRedirect",
            "getCompany",
            "getCompanyName",
            "getDeliveryRedirect"
        ]),
        hasRedirect () {
            const redirect = this.getDeliveryRedirect
            const result   = redirect.length > 0
            console.log ("HAS delivery Redirecit", redirect, result)
            return result
        }
    },
    methods: {
        hasAnyPermission() {
            let result   = false
            const groups = this.$store.state.user.user.groups
            for (let p of arguments) {
                result = result | groups.has (p)
            }
            return result
        },
        isActive:function (menuItem) {
            return this.currentactive === menuItem;
        },
        shopDeliveryClicked () {
            const url =localStorage.getItem ("deliveryRedirect")
            this.$store.dispatch ("shopDeliveryClicked",{url:url})

        }
    },
}
</script>
<style>
.active{
    background-color:#a72523;
    font-weight: bold;
}

.menu-vert{
    color:#fff!important;
}

.menu-vert-menu{
    background-color: #2d2d2d;
    color:#fff!important;
}

.menu-vert-menu-item{
    border-bottom: 1px solid #fff;
    padding: 10px 20px;
    color:#fff!important;
    cursor:pointer;
}

.menu-vert-menu-item-item{
    padding-left:20px;
    padding-top:2px;
    padding-bottom:2px;
    font-size:12px;
    font-weight:normal;
}

.menu-vert-menu-item a{
    color:#fff!important;
}

.menu-vert-top{
    padding:20px 5px 0px 20px;
    margin-bottom:10px;
    background-color: #2d2d2d;
    color:#fff!important;
}

.menu-vert-top h2 {
    padding-bottom: 5px;
    margin-bottom:  5px;
}

.menu-vert-menu-item-logout{
    margin-top:40%;
    padding:15px;
    color:#fff!important;
}
</style>
